import { Group } from "../../../dto/group"
import httpClient from "../../../service/api"

export const findData = async () : Promise<Group[]> => {
  const response: any = await httpClient.get("/api/group")
  return response.data
}

export const deleteGroup = async (group:Group) : Promise<void> => {
  await httpClient.get(`/api/group/delete/${group.id}`)
}